import { Logger } from 'lib'
import { AnalyticsEventTypes } from 'Common/Service/Analytics/constants'

const XSSOStates = {
  Init: 'init',
  Set: 'set',
  Unchanged: 'unchanged',
  PollAborted: 'poll_aborted',
  LoginRequired: 'login_required',
  Limited: 'limited'
}

class XSSOStateTracker {
  /**
   * @type {import('Common/Service/Analytics/types').IAnalyticsService}
   */
  #analyticsService

  /**
   * @type {import('Common/Service/FeatureFlags/types').IFeatureFlagsService}
   */
  #featureFlagsService

  mutPlayerState = undefined

  constructor () {
    this.log = new Logger(this.constructor.name)
  }

  getXSSO () {
    return window.xsso
  }

  initialize () {
    const xsso = this.getXSSO()

    if (xsso) {
      this.mutPlayerState = xsso.state()
      xsso.onEvent((type) => {
        if (type instanceof Error) {
          this.log.error(type)
          return
        }

        if (this.mutPlayerState === type) {
          return
        }

        if (
          (this.mutPlayerState === XSSOStates.Set
            || this.mutPlayerState === XSSOStates.Limited)
          && type === XSSOStates.LoginRequired
        ) {
          this.log.info('User session lost')

          if (this.#analyticsService) {
            this.#analyticsService.track(AnalyticsEventTypes.XssoStateChange, {
              xssoState: type,
              previousState: this.mutPlayerState
            })

            this.#analyticsService.reset()
          }

          if (this.#featureFlagsService) {
            this.#featureFlagsService.reset()
          }
        }
        else if (type === XSSOStates.Limited) {
          this.log.info('User session limited')

          if (this.#analyticsService) {
            this.#analyticsService.track(AnalyticsEventTypes.XssoStateChange, {
              xssoState: type,
              previousState: this.mutPlayerState
            })
          }
        }

        this.mutPlayerState = type
      })
    }
  }

  /**
   * @param {import('Common/Service/Analytics/types').IAnalyticsService} analyticsService
   */
  setAnalyticsService (analyticsService) {
    this.#analyticsService = analyticsService
  }

  /**
   * @param {import('Common/Service/FeatureFlags/types').IFeatureFlagsService} featureFlagsService
   */
  setFeatureFlagsService (featureFlagsService) {
    this.#featureFlagsService = featureFlagsService
  }
}

export default new XSSOStateTracker()
